import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { catchError, tap } from 'rxjs/operators';
import { Observable, of } from 'rxjs';

import { Services } from './../services-url';

@Injectable({
  providedIn: 'root'
})
export class MunicipalitiesService {

  constructor(
    private http: HttpClient,
  ) { }

  getYears():Observable<any>{
    return this.http.get(Services.yearsMunicipalities);
    
  }

  getDepartaments():Observable<any>{
    return this.http.get(`${Services.departamentsMunicipalities}`);
   
  }


  getMunicipalities(depCode):Observable<any>{
    return this.http.get(`${Services.municipalities}/${depCode}`);
  }

  getIndicator(munCode,year):Observable<any>{

    return this.http.get(`${Services.indicatorMunicipality}/${year}/${munCode}`);
  }

  getIndicatorsDetails(munCode,years):Observable<any>{
    return this.http.get(`${Services.indicatorMunicipalityDetails}/${munCode}/${years[0]}/${years[1]}`);
  }
}
